import * as schemas from "~/schemas/schema.attachments";
import * as commentsSchema from "~/schemas/schema.comments";
import * as discussionsSchema from "~/schemas/schema.discussions";
import * as notesSchema from "~/schemas/schema.notes";
import * as tasksSchema from "~/schemas/schema.tasks";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import { encodeData } from "~/utils/utils.jsx";

export const removeAttachedFile = (attachmentId, formKey) => {
  return {
    type: actionTypes.REMOVE_ATTACHED_FILE,
    attachmentId,
    formKey,
  };
};

export const fetchAttachment = (id) => {
  return {
    types: [
      actionTypes.FETCH_ATTACHMENT_LOADING,
      actionTypes.FETCH_ATTACHMENT_SUCCESS,
      actionTypes.FETCH_ATTACHMENT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/attachments/${id}`,
      }),
    payload: {
      id,
      schema: {
        single: schemas.attachment,
      },
    },
  };
};

export const fetchAttachments = (projectId, folderId, cursor, signal, limit) => {
  const values = {
    limit: limit ?? 50,
  };

  if (cursor && cursor > 0) {
    values.cursor = cursor;
  }

  let query = encodeData(values);

  if (query) {
    query = "?" + query;
  }

  return {
    types: [
      actionTypes.FETCH_ATTACHMENTS_LOADING,
      actionTypes.FETCH_ATTACHMENTS_SUCCESS,
      actionTypes.FETCH_ATTACHMENTS_ERROR,
    ],
    callAPI: () => {
      const path = folderId
        ? `${Angie.api_url}/projects/${projectId}/folders/${folderId}/attachments${query}`
        : `${Angie.api_url}/projects/${projectId}/folders/attachments${query}`;
      return fetch({
        url: path,
        withHeaders: true,
        signal,
      });
    },
    payload: {
      projectId,
      folderId,
      schema: {
        attachments: schemas.arrayOfAttachments,
        attachment_parents: {
          Task: tasksSchema.arrayOfTasks,
          Note: notesSchema.arrayOfNotes,
          Comment: commentsSchema.arrayOfComments,
          Discussion: discussionsSchema.arrayOfDiscussions,
        },
      },
    },
  };
};

export const deleteAttachment = (id) => {
  return {
    types: [
      actionTypes.DELETE_ATTACHMENT_LOADING,
      actionTypes.DELETE_ATTACHMENT_SUCCESS,
      actionTypes.DELETE_ATTACHMENT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/attachments/${id}`,
        method: "DELETE",
      }),
    payload: { id },
  };
};

export const moveAttachment = (id, targetFolderId) => {
  return {
    types: [
      actionTypes.MOVE_ATTACHMENT_LOADING,
      actionTypes.MOVE_ATTACHMENT_SUCCESS,
      actionTypes.MOVE_ATTACHMENT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/attachments/${id}/move-to-folder`,
        method: "PUT",
        body: {
          target_folder_id: targetFolderId,
        },
      }),
    payload: {
      id,
      targetFolderId,
      schema: {
        single: schemas.attachment,
      },
    },
  };
};

export const editAttachment = (id, attributes) => {
  return {
    types: [
      actionTypes.EDIT_ATTACHMENT_LOADING,
      actionTypes.EDIT_ATTACHMENT_SUCCESS,
      actionTypes.EDIT_ATTACHMENT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/attachments/${id}`,
        method: `PUT`,
        body: attributes,
      }),
    payload: {
      id,
      attributes,
      schema: {
        single: schemas.attachment,
      },
    },
  };
};
